"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getXAxisMinMax = exports.getAxisRange = exports.getLineRangeMinMax = void 0;
const volatilitySmile_1 = require("../calculationsCore/volatilitySmile");
const types_1 = require("../types");
// 90% padding on creating viewport
const X_AXIS_PADDING = 0.9;
const Y_AXIS_PADDING = 0.9;
const getLineRangeMinMax = (minDomainX, maxDomainX, domain, values) => {
    let min = Number.MAX_SAFE_INTEGER;
    let max = Number.MIN_SAFE_INTEGER;
    for (let i = 0; i < domain.length; i++) {
        if (domain[i] >= minDomainX && domain[i] <= maxDomainX) {
            min = Math.min(min, values[i]);
            max = Math.max(max, values[i]);
        }
    }
    return { min, max };
};
exports.getLineRangeMinMax = getLineRangeMinMax;
const getAxisRange = (index, positions) => {
    const X_AXIS_PADDING = 0.5;
    const range = (0, exports.getXAxisMinMax)(index, positions);
    return {
        min: range.min - range.min * X_AXIS_PADDING,
        max: range.max + range.max * X_AXIS_PADDING,
    };
};
exports.getAxisRange = getAxisRange;
const getXAxisMinMax = (index, positions) => {
    let minStrike = Number.MAX_SAFE_INTEGER;
    let maxStrike = Number.MIN_SAFE_INTEGER;
    for (const position of positions) {
        if (position.positionType === types_1.PositionType.Option) {
            const strike = (0, volatilitySmile_1.getOptionInstrumentParts)(position.instrument).strike;
            minStrike = Math.min(minStrike, strike);
            maxStrike = Math.max(maxStrike, strike);
        }
    }
    return {
        min: Math.min(minStrike, index),
        max: Math.max(maxStrike, index),
    };
};
exports.getXAxisMinMax = getXAxisMinMax;
